import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";
import Single from "./pages/single/Single";
import New from "./pages/new/New";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { userInputs } from "./formSource";
import "./style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import ProtectedRoute from "./ProtectedRoute";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Library from "./pages/library/library";
import SingleUser from "./pages/singleUser/singleUser";
import EditBook from "./pages/editBook/editBook";
import AddNewBook from "./pages/addNewBook/addNewBook"
import AddPublisher from "./pages/addPublisher/addPublisher"
import AppBanners from "./pages/appBanners/appBanners"
import PendingBooks from "./pages/pendingBooks/pendingBooks"
import Promocodes from "./pages/promocodes/promocodes"
import Setiings from "./pages/setiings/setiings"
import Support from "./pages/support/support"
import PublisherList from "./pages/publisherList/publisherList";
import Orders from "./pages/orders/orders";
import SingleBook from "./pages/singleBook/singleBook";
import SingleBookPending from "./pages/singleBookPending/singleBookPending";
import OrderDetails from "./pages/orderDetails/orderDetails";
import SinglePublisher from "./pages/singlePublisher/singlePublisher";
import NotFound from "./NotFound"
import PendingReview from "./pages/pendingReviews/pendingReview";
import BooksJson from "./pages/booksJson/booksJson";
import PendingBooksJson from "./pages/pendingBooksJson/pendingBooksJson";

const theme = createTheme({
  typography: {
    fontFamily: 'Rubik, sans-serif', // Add your font here
  },
});

function App() {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <ThemeProvider theme={theme}>
      <div className={darkMode ? "app dark" : "app"}>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route path="/">
              <Route path="login" element={<Login />} />
              <Route
                index
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="add-book"
                element={
                  <ProtectedRoute>
                    <AddNewBook />
                  </ProtectedRoute>
                }
              />
              <Route
                path="add-publisher"
                element={
                  <ProtectedRoute>
                    <AddPublisher />
                  </ProtectedRoute>
                }
              />
              <Route
                path="pending-reviews"
                element={
                  <ProtectedRoute>
                    <PendingReview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="pending-books">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <PendingBooks />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":productId"
                  element={
                    <ProtectedRoute>
                      <SingleBookPending />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":productId/edit"
                  element={
                    <ProtectedRoute>
                      <EditBook />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route
                path="app-banners"
                element={
                  <ProtectedRoute>
                    <AppBanners />
                  </ProtectedRoute>
                }
              />
              <Route
                path="support"
                element={
                  <ProtectedRoute>
                    <Support />
                  </ProtectedRoute>
                }
              />
              <Route
                path="settings"
                element={
                  <ProtectedRoute>
                    <Setiings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="books-json"
                element={
                  <ProtectedRoute>
                    <BooksJson />
                  </ProtectedRoute>
                }
              />
              <Route
                path="pending-books-json"
                element={
                  <ProtectedRoute>
                    <PendingBooksJson />
                  </ProtectedRoute>
                }
              />
              <Route
                path="orders">
                <Route index element={
                  <ProtectedRoute>
                    <Orders />
                  </ProtectedRoute>
                } />
                <Route
                  path=":orderId"
                  element={
                    <ProtectedRoute>
                      <OrderDetails />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route
                path="promocodes"
                element={
                  <ProtectedRoute>
                    <Promocodes />
                  </ProtectedRoute>
                }
              />
              <Route path="users">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <List />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":userId"
                  element={
                    <ProtectedRoute>
                      <SingleUser />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="new"
                  element={
                    <ProtectedRoute>
                      <New inputs={userInputs} title="Add New User" />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route path="library">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <Library />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":productId"
                  element={
                    <ProtectedRoute>
                      <SingleBook />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":productId/edit"
                  element={
                    <ProtectedRoute>
                      <EditBook />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route path="publishers">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <PublisherList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":publisherId"
                  element={
                    <ProtectedRoute>
                      <SinglePublisher />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":publisherId/edit"
                  element={
                    <ProtectedRoute>
                      <EditBook />
                    </ProtectedRoute>
                  }
                />
              </Route>

            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
